import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { AxiosInstance } from 'axios';
import { AddRolePayload, AssignRolePayload } from './roles.types';

export const roleMutations = {
  createRole: (client: AxiosInstance) => async (body: AddRolePayload) => {
    return (await client.post<ApiResponse>('/create-role-type', body)).data;
  },
  assignRole: (client: AxiosInstance) => async (body: AssignRolePayload) => {
    return (await client.post<ApiResponse>('/assign-role', body)).data;
  },
};
